import { searchInputStyles } from "@insite/content-library/Widgets/Header/HeaderSearchInput";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import HeaderSearchInputIcon from "@tFissco/Icons/HeaderSearchInputIcon";
import { css } from "styled-components";

searchInputStyles.searchInputStyles = {
    input: {
        iconProps: {
            src: HeaderSearchInputIcon,
            size: 60,
        },
        css: css`
            background: ${getColor("common.background")} !important;
            border: 1px solid ${getColor("common.border")} !important;
            font-size: 1rem !important;
            border-radius: 6px !important;
            height: 42px !important;
        `,
        cssOverrides: {
            formInputWrapper: css`
                ${StyledButton} {
                    font-family: "OpenSansRegular";
                    position: absolute;
                    top: -2px;
                    right: -1px;
                    width: 40px;
                    height: 42px;
                    &:focus {
                        outline-width: 0px;
                    }
                }
                ${IconWrapper} {
                    background-color: ${getColor("common.accent")};
                    border-radius: 0px 6px 6px 0px;
                    width: 100%;
                    padding: 0px;
                    height: inherit;
                    justify-content: center;
                    svg {
                        width: 20px !important;
                        height: 18px !important;
                    }
                }
            `,
        },
    },
    popoverContentBody: {
        css: css`
            overflow: hidden;
            z-index: 9999999;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        width: 88.5%;
                        right: inherit !important;
                        left: 6%;
                    `,
                    css`
                        width: 93%;
                    `,
                    css`
                        width: 89.5%;
                    `,
                    css`
                        margin-right: 1rem;
                        width: 34vw;
                    `,
                    css`
                        width: 35vw;
                    `,
                ]);
            }}
            > div[class^="sc"] {
                font-family: "MontserratRegular";
                font-size: 14px;
                max-height: 80vh;
                overflow-y: auto;
                z-index: 999999999;
                position: relative;

                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css``,
                        css``,
                        css``,
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: column;
                        `,
                    ]);
                }}
            }
        `,
    },
};
